import { FC, useContext, useMemo } from 'react';
import { isMobile } from 'react-device-detect';
import { HomePageContext } from 'src/constructors/pageConstructors/HomePageConstructor';
import HomeWidgets from './HomeWidgets';

export type Props = {
  settings: { priority: number; styles: Styles; type: string };
  type: string;
};

export const HomeWidgetsWrapper: FC<Props> = ({ settings, type }) => {
  const homePageContext = useContext(HomePageContext);

  const homeWidgetsData = useMemo(() => {
    if (type === 'home') {
      return isMobile ? homePageContext?.pageFields?.actionGridMobile : homePageContext?.pageFields?.actionGridDesktop;
    }
    return null;
  }, [homePageContext]);

  return <HomeWidgets homeWidgetsData={homeWidgetsData} settings={settings} />;
};

export default HomeWidgetsWrapper;
